import { pbxLocationsEn } from './en'

export const pbxLocationsEnCa = pbxLocationsEn
